<template>
  <div class="schedule-container-class">
    <div 
      v-for="(day, index) in weekDays" 
      :key="index" 
      class="schedule-card-class" 
      :class="{ today: isToday(parseInt(day.date)) }"
    >
      <div class="schedule-header">
        <div>{{ day.shortName }}</div>
        <div>{{ day.date }}</div>
      </div>
      <div class="schedule-content">
        <div v-if="getEventsForDay(day.fullDate).length">
          <div 
            v-for="(event, idx) in getEventsForDay(day.fullDate)" 
            :key="idx" 
            class="schedule-event"
          >
            <div class="d-flex">
              <div>{{ event.displayName }}</div>
              <div>{{ $global.formatTime(event.startDateTime) }}</div>
            </div>
          </div>
        </div>
        <div 
          v-else 
          class="text-center font-italic text-secondary"
          style="font-size: 14px;"
        >
          No event/s
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    events: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    weekDays() {
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const shortDays = ["S", "M", "T", "W", "Th", "F", "S"];
      let today = dayjs();

      return Array.from({ length: 5 }, (_, i) => {
        let date = today.add(i, "day");
        return {
          name: days[date.day()],
          shortName: shortDays[date.day()],
          date: date.format("DD"),
          fullDate: date.format("YYYY-MM-DD"),
        };
      });
    }
  },
  methods: {
    isToday(date) {
      return parseInt(dayjs().date()) === date;
    },
    getEventsForDay(date) {
      return this.events.filter(event => {
        const eventDate = dayjs(event.startDateTime).format("YYYY-MM-DD");
        return eventDate === date;
      });
    },
  },
};
</script>
<style scoped>
.schedule-container-class {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  overflow-x: auto;
}

.schedule-card-class {
  background: #fff;
  border-radius: 10px;
  min-width: 180px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
  border: 1px solid #ccc;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.schedule-card-class.today .schedule-header {
  background: red;
  color: white;
}

.schedule-event {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 5px;
  overflow: hidden;
}

.schedule-event div:first-child {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-content .schedule-event:nth-child(odd) {
  background: #ececec;
}
</style>
